// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"845":"d9d34f346ebe9b60","1655":"12564915f98538f3","3259":"a3743af132f06df7","7125":"01cd8ba980bef64b"}[chunkId] + ".css";
};